/** @jsx jsx */
import { CompanyAvatar, CompanyAvatarProps } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { useAttachmentQuery } from "@/data/attachments";
import { CompanyBase } from "@/data/companies/types/CompanyBase";

interface LazyCompanyAvatarProps extends CompanyAvatarProps {
  company: CompanyBase;
}

export const LazyCompanyAvatar: FC<LazyCompanyAvatarProps> = ({ company, ...avatarProps }) => {
  const { data } = useAttachmentQuery(company.logo);

  return <CompanyAvatar name={company.name} img={data?.publicUrl ?? undefined} {...avatarProps} />;
};
